import React from 'react';

const MedicalDisclaimer = () => {
  return (
    <div className="page-legal">
      <div className="container">
        <div className="legal-content">
          <h1 className="heading-1">Medical Disclaimer</h1>
          <p className="legal-updated">Last Updated: January 2025</p>
          
          <p className="body-regular legal-intro">
            Please read this disclaimer carefully before using the Glow Health website or services.
          </p>

          <section className="legal-section">
            <h2 className="heading-3">Educational Information Only</h2>
            <p className="body-regular">
              The information provided on this website, including content about hormone health, 
              symptoms, and wellness, is intended for general educational purposes only. This 
              information is not a substitute for professional medical advice, diagnosis, or 
              treatment.
            </p>
          </section>

          <section className="legal-section">
            <h2 className="heading-3">Provider-Directed Care</h2>
            <p className="body-regular">
              All diagnosis and treatment decisions at Glow Health are made by licensed 
              healthcare providers after a thorough evaluation of your individual health 
              history, symptoms, and needs. No information on this website should be used 
              to self-diagnose or self-treat any health condition.
            </p>
          </section>

          <section className="legal-section">
            <h2 className="heading-3">Individual Results Vary</h2>
            <p className="body-regular">
              Every person&apos;s body is unique, and individual results from hormone health 
              care will vary. Testimonials or descriptions of outcomes on this website 
              reflect individual experiences and are not guarantees of specific results. 
              Your experience may differ based on your personal health circumstances.
            </p>
          </section>

          <section className="legal-section">
            <h2 className="heading-3">No Guarantees</h2>
            <p className="body-regular">
              Nothing on this website guarantees specific health outcomes, symptom resolution, 
              or treatment success. Hormone health is complex, and while we are committed to 
              providing thoughtful, personalized care, we cannot promise particular results.
            </p>
          </section>

          <section className="legal-section">
            <h2 className="heading-3">Seek Emergency Care When Appropriate</h2>
            <p className="body-regular">
              <strong>If you are experiencing a medical emergency, please call 911 or go to 
              your nearest emergency room immediately.</strong> Glow Health does not provide 
              emergency medical services. Our care is designed for ongoing, non-urgent hormone 
              health support.
            </p>
          </section>

          <section className="legal-section">
            <h2 className="heading-3">Consult Your Healthcare Provider</h2>
            <p className="body-regular">
              Always consult with a qualified healthcare provider before making decisions 
              about your health. If you have questions or concerns about a medical condition, 
              please speak with a licensed professional who can evaluate your specific situation.
            </p>
          </section>

          <section className="legal-section">
            <h2 className="heading-3">Contact Us</h2>
            <p className="body-regular">
              If you have questions about this disclaimer, please contact us at:
            </p>
            <p className="body-regular legal-contact">
              <strong>Email:</strong> support@myglowhealth.co
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default MedicalDisclaimer;
